import React from "react";
import { useTranslation } from "react-i18next";

export default function LogiWorkLandingConnect(props) {
  const { setIsInquiryModalOpen } = props;
  const { t } = useTranslation();
  return (
    <>
      <div className="bg-light">
        <div className="container-xl p-5">
          <p className="BM-DH h2 text-center">
            {t("logiWorkLanding.connect.title")}
          </p>
          <div className="row">
            <div className="col-md-6 p-2">
              <div className="rounded-lg bg-white p-5 shadow-sm d-flex flex-column align-items-center h-100">
                <img
                  className="mb-2"
                  src="/img/use_img/partron_logo.png"
                  alt="logo"
                />
                <p className="h6 font-weight-bold border-bottom border-dark">
                  {t("logiWorkLanding.connect.partron.partName")}
                </p>
                <p className="h6 text-center">
                  {t("logiWorkLanding.connect.partron.description")}
                </p>
              </div>
            </div>
            <div className="col-md-6 p-2">
              <div className="rounded-lg bg-white p-5 shadow-sm d-flex flex-column align-items-center h-100">
                <img src="/img/use_img/junglim_logo.png" alt="logo" />
                <p className="h6 font-weight-bold border-bottom border-dark">
                  {t("logiWorkLanding.connect.jungLim.partName")}
                </p>
                <p className="h6  text-center">
                  {t("logiWorkLanding.connect.jungLim.description")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ background: "#7fb2c2" }}>
        <div className="container-xl p-5">
          <div className="py-5">
            <p className="BM-DH h2 text-center text-white">
              {t("logiWorkLanding.connect.inquiryTitle")}
            </p>
            <p className="h4 font-weight-bold text-center text-dark">
              {t("logiWorkLanding.connect.inquiryDesc")}
            </p>
            <div className="text-center">
              <button
                className="btn btn-info bg-freiscop border-freiscop"
                onClick={() => setIsInquiryModalOpen(true)}
              >
                {t("logiWorkLanding.connect.inquiry")}{" "}
                <i className="fa-solid fa-arrow-right ml-2" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
